import { Inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoTranspiler, TRANSLOCO_TRANSPILER } from '@ngneat/transloco';

@Pipe({
  name: 'i18nParser',
  pure: true,
})
export class TranspileParserPipe implements PipeTransform {
  constructor(
    @Inject(TRANSLOCO_TRANSPILER) private parser: TranslocoTranspiler
  ) {}

  transform(value: string, props: Record<string, any>): any {
    return this.parser.transpile(value, props, {});
  }
}
